var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    this.specificVo.beneGroup == "MEA" && this.lgTypeVo == 5
      ? _c("div", { staticClass: "form-row div-valign" }, [
          _c("div", { staticClass: "form-group col-md-6" }, [
            _c("label", [_vm._v("บัญชีแสดงสัญญา")]),
            _c("span", { staticClass: "required" }, [_vm._v("*")]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.caNo,
                  expression: "caNo"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: true, max: 20 },
                  expression: "{required:true,max:20}"
                }
              ],
              staticClass: "form-control",
              class: { input: true, "is-danger": _vm.errors.has("caNo") },
              attrs: {
                name: "caNo",
                disabled: this.reqType !== 1 && this.appVo.modifyFlag !== "Y",
                type: "text"
              },
              domProps: { value: _vm.caNo },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.caNo = $event.target.value
                }
              }
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("caNo"),
                    expression: "errors.has('caNo')"
                  }
                ],
                staticClass: "help is-danger"
              },
              [_vm._v("กรุณากรอก บัญชีแสดงสัญญา")]
            )
          ]),
          _c("div", { staticClass: "form-group col-md-6" }, [
            _c("label", [_vm._v("เครื่องวัดไฟฟ้าเลขที่")]),
            _c("span", { staticClass: "required" }, [_vm._v("*")]),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.meterNo,
                  expression: "meterNo"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: true, max: 20 },
                  expression: "{required:true,max:20}"
                }
              ],
              staticClass: "form-control",
              class: { input: true, "is-danger": _vm.errors.has("meterNo") },
              attrs: {
                name: "meterNo",
                disabled: this.reqType !== 1 && this.appVo.modifyFlag !== "Y",
                type: "text"
              },
              domProps: { value: _vm.meterNo },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.meterNo = $event.target.value
                }
              }
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("meterNo"),
                    expression: "errors.has('meterNo')"
                  }
                ],
                staticClass: "help is-danger"
              },
              [_vm._v("กรุณากรอก เครื่องวัดไฟฟ้าเลขที่")]
            )
          ])
        ])
      : _vm._e(),
    this.specificVo.ctrNoFlag == "Y"
      ? _c("div", { staticClass: "form-row div-valign" }, [
          _c("div", { staticClass: "form-group col-md-6" }, [
            _c("label", [_vm._v(_vm._s(_vm.txtCtrNo))]),
            this.isRequiredCtrNo
              ? _c("span", { staticClass: "required" }, [_vm._v("*")])
              : _vm._e(),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.ctrNo,
                  expression: "ctrNo"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: this.isRequiredCtrNo },
                  expression: "{ required: this.isRequiredCtrNo }"
                }
              ],
              staticClass: "form-control",
              class: { input: true, "is-danger": _vm.errors.has("ctrNo") },
              attrs: {
                name: "ctrNo",
                "data-vv-as": "ข้อมูล",
                disabled: this.reqType !== 1 && this.appVo.modifyFlag !== "Y",
                maxlength: "50",
                type: "text"
              },
              domProps: { value: _vm.ctrNo },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.ctrNo = $event.target.value
                }
              }
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("ctrNo"),
                    expression: "errors.has('ctrNo')"
                  }
                ],
                staticClass: "help is-danger"
              },
              [_vm._v("กรุณากรอก " + _vm._s(_vm.txtCtrNo))]
            )
          ])
        ])
      : _vm._e(),
    this.specificVo.ctrNameFlag == "Y"
      ? _c("div", { staticClass: "form-row div-valign" }, [
          _c("div", { staticClass: "form-group col-md-6" }, [
            _c("label", [_vm._v(_vm._s(_vm.txtCtrName))]),
            this.isRequiredCtrName
              ? _c("span", { staticClass: "required" }, [_vm._v("*")])
              : _vm._e(),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.ctrName,
                  expression: "ctrName"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: this.isRequiredCtrName },
                  expression: "{ required: this.isRequiredCtrName }"
                }
              ],
              staticClass: "form-control",
              class: { input: true, "is-danger": _vm.errors.has("ctrName") },
              attrs: {
                name: "ctrName",
                "data-vv-as": "ชื่อสัญญา",
                disabled: this.reqType !== 1 && this.appVo.modifyFlag !== "Y",
                maxlength: "200",
                type: "text"
              },
              domProps: { value: _vm.ctrName },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.ctrName = $event.target.value
                }
              }
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("ctrName"),
                    expression: "errors.has('ctrName')"
                  }
                ],
                staticClass: "help is-danger"
              },
              [_vm._v("กรุณากรอก " + _vm._s(_vm.txtCtrName))]
            )
          ])
        ])
      : _vm._e(),
    this.specificVo.ctrDateFlag == "Y"
      ? _c("div", { staticClass: "form-row div-valign" }, [
          _c(
            "div",
            { staticClass: "form-group col-md-6" },
            [
              _c("label", [_vm._v(_vm._s(_vm.txtCtrDate))]),
              this.isRequiredCtrDate
                ? _c("span", { staticClass: "required" }, [_vm._v("*   ")])
                : _vm._e(),
              this.txtCtrDate.length < 17
                ? _c("span", { staticClass: "text-white" }, [
                    _vm._v("         ")
                  ])
                : _vm._e(),
              _c("date-picker", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: { required: this.isRequiredCtrDate },
                    expression: "{ required: this.isRequiredCtrDate }"
                  }
                ],
                ref: "ctrDate",
                class: { input: true, "is-danger": _vm.errors.has("ctrDate") },
                attrs: {
                  name: "ctrDate",
                  format: "DD/MM/YYYY",
                  disabled: this.reqType !== 1 && this.appVo.modifyFlag !== "Y",
                  "data-vv-as": "ข้อมูล",
                  lang: "th",
                  placeholder: ""
                },
                model: {
                  value: _vm.ctrDate,
                  callback: function($$v) {
                    _vm.ctrDate = $$v
                  },
                  expression: "ctrDate"
                }
              }),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("ctrDate"),
                      expression: "errors.has('ctrDate')"
                    }
                  ],
                  staticClass: "help is-danger"
                },
                [_vm._v("กรุณากรอก " + _vm._s(_vm.txtCtrDate))]
              )
            ],
            1
          )
        ])
      : _vm._e(),
    this.specificVo.hcodeFlag == "Y"
      ? _c("div", { staticClass: "form-row div-valign" }, [
          this.specificVo.hcodeFlag == "Y"
            ? _c("div", { staticClass: "form-group col-md-6" }, [
                _c("label", [_vm._v(" รหัสสถานบริการ (H Code) ")]),
                this.isRequiredBeneRemark
                  ? _c("span", { staticClass: "required" }, [_vm._v("*")])
                  : _vm._e(),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.hospitalCode,
                      expression: "hospitalCode"
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: { required: this.isRequiredBeneRemark },
                      expression: "{ required: this.isRequiredBeneRemark }"
                    }
                  ],
                  staticClass: "form-control",
                  class: {
                    input: true,
                    "is-danger": _vm.errors.has("hospitalCode")
                  },
                  attrs: {
                    name: "hospitalCode",
                    "data-vv-as": "รหัสสถานบริการ (H Code)",
                    disabled:
                      this.reqType !== 1 && this.appVo.modifyFlag !== "Y",
                    maxlength: "5",
                    type: "text"
                  },
                  domProps: { value: _vm.hospitalCode },
                  on: {
                    blur: function($event) {
                      return _vm.gethospitalName()
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.hospitalCode = $event.target.value
                    }
                  }
                }),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("hospitalCode"),
                        expression: "errors.has('hospitalCode')"
                      }
                    ],
                    staticClass: "help is-danger"
                  },
                  [_vm._v(_vm._s(_vm.errors.first("hospitalCode")))]
                )
              ])
            : _vm._e()
        ])
      : _vm._e(),
    this.specificVo.hnameFlag == "Y"
      ? _c("div", { staticClass: "form-row div-valign" }, [
          this.specificVo.hnameFlag == "Y"
            ? _c("div", { staticClass: "form-group col-md-12" }, [
                _c("label", [_vm._v(" ชื่อสถานบริการ ")]),
                this.isRequiredBeneRemark
                  ? _c("span", { staticClass: "required" }, [_vm._v("*")])
                  : _vm._e(),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.hospitalName,
                      expression: "hospitalName"
                    },
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: { required: this.isRequiredBeneRemark },
                      expression: "{ required: this.isRequiredBeneRemark }"
                    }
                  ],
                  staticClass: "form-control",
                  class: {
                    input: true,
                    "is-danger": _vm.errors.has("hospitalName")
                  },
                  attrs: {
                    name: "hospitalName",
                    "data-vv-as": "ชื่อสถานบริการ",
                    disabled: "true",
                    maxlength: "500",
                    type: "text"
                  },
                  domProps: { value: _vm.hospitalName },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.hospitalName = $event.target.value
                    }
                  }
                }),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("hospitalName"),
                        expression: "errors.has('hospitalName')"
                      }
                    ],
                    staticClass: "help is-danger"
                  },
                  [_vm._v(_vm._s(_vm.errors.first("hospitalName")))]
                )
              ])
            : _vm._e()
        ])
      : _vm._e(),
    this.specificVo.contractTypeFlag == "Y"
      ? _c("div", { staticClass: "form-row div-valign" }, [
          _c("div", { staticClass: "form-group col-md-6" }, [
            _c("label", [_vm._v("ประเภทสัญญา")]),
            this.isRequiredBeneRemark
              ? _c("span", { staticClass: "required" }, [_vm._v("*")])
              : _vm._e(),
            _c(
              "select",
              {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.contractTypeId,
                    expression: "contractTypeId"
                  },
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: { required: this.isRequiredBeneRemark },
                    expression: "{ required: this.isRequiredBeneRemark }"
                  }
                ],
                staticClass: "form-control",
                class: {
                  input: true,
                  "is-danger": _vm.errors.has("contractTypeId")
                },
                attrs: { name: "contractTypeId", disabled: "" },
                on: {
                  change: function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.contractTypeId = $event.target.multiple
                      ? $$selectedVal
                      : $$selectedVal[0]
                  }
                }
              },
              [
                _c("option", { attrs: { value: "" } }, [_vm._v("กรุณาเลือก")]),
                _vm._l(_vm.contractTypeList, function(option) {
                  return _c(
                    "option",
                    {
                      key:
                        option.contractTypeId + "-" + option.contractTypeDesc,
                      domProps: {
                        value: {
                          contractTypeId: option.contractTypeId,
                          contractTypeDesc: option.contractTypeDesc
                        }
                      }
                    },
                    [_vm._v(_vm._s(option.contractTypeDesc))]
                  )
                })
              ],
              2
            ),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("contractTypeId"),
                    expression: "errors.has('contractTypeId')"
                  }
                ],
                staticClass: "help is-danger"
              },
              [_vm._v("กรุณากรอก ประเภทสัญญา")]
            )
          ])
        ])
      : _vm._e(),
    this.specificVo.beneRemarkFlag == "Y"
      ? _c("div", { staticClass: "form-row div-valign" }, [
          _c("div", { staticClass: "form-group col-md-12" }, [
            _c("label", [_vm._v(" " + _vm._s(_vm.labelBeneRemark) + " ")]),
            this.isRequiredBeneRemark
              ? _c("span", { staticClass: "required" }, [_vm._v("*")])
              : _vm._e(),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.beneficiaryRemark,
                  expression: "beneficiaryRemark"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: this.isRequiredBeneRemark },
                  expression: "{ required: this.isRequiredBeneRemark }"
                }
              ],
              staticClass: "form-control",
              class: {
                input: true,
                "is-danger": _vm.errors.has("beneficiaryRemark")
              },
              attrs: {
                name: "beneficiaryRemark",
                "data-vv-as": "ข้อมูล",
                disabled:
                  this.reqType !== 1 &&
                  this.appVo.modifyFlag !== "Y" &&
                  this.specificVo.beneGroup !== "NHSO",
                maxlength: "500",
                type: "text"
              },
              domProps: { value: _vm.beneficiaryRemark },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.beneficiaryRemark = $event.target.value
                }
              }
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("beneficiaryRemark"),
                    expression: "errors.has('beneficiaryRemark')"
                  }
                ],
                staticClass: "help is-danger"
              },
              [_vm._v("กรุณากรอก " + _vm._s(_vm.labelBeneRemark))]
            )
          ])
        ])
      : _vm._e(),
    this.specificVo.dealerCodeFlag == "Y"
      ? _c("div", { staticClass: "form-row div-valign" }, [
          _c("div", { staticClass: "form-group col-md-6" }, [
            _c("label", [_vm._v(" " + _vm._s(_vm.labelDealerCode) + " ")]),
            this.isRequiredDealerCode
              ? _c("span", { staticClass: "required" }, [_vm._v("*")])
              : _vm._e(),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.dealerCode,
                  expression: "dealerCode"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: this.isRequiredDealerCode },
                  expression: "{ required: this.isRequiredDealerCode }"
                }
              ],
              staticClass: "form-control",
              class: { input: true, "is-danger": _vm.errors.has("dealerCode") },
              attrs: {
                name: "dealerCode",
                "data-vv-as": "ข้อมูล",
                disabled: this.reqType !== 1 && this.appVo.modifyFlag !== "Y",
                maxlength: "500",
                type: "text"
              },
              domProps: { value: _vm.dealerCode },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.dealerCode = $event.target.value
                }
              }
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("dealerCode"),
                    expression: "errors.has('dealerCode')"
                  }
                ],
                staticClass: "help is-danger"
              },
              [_vm._v("กรุณากรอก " + _vm._s(_vm.labelDealerCode))]
            )
          ])
        ])
      : _vm._e(),
    this.specificVo.ctrDatePEAFlag == "Y"
      ? _c("div", { staticClass: "form-row div-valign" }, [
          _c(
            "div",
            { staticClass: "form-group col-md-6" },
            [
              _c("label", [_vm._v("สัญญาลงวันที่")]),
              this.isRequiredCtrDatePEA
                ? _c("span", { staticClass: "required" }, [_vm._v("*")])
                : _vm._e(),
              _c("date-picker", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: { required: this.isRequiredCtrDatePEA },
                    expression: "{ required: this.isRequiredCtrDatePEA }"
                  }
                ],
                ref: "ctrDatePEA",
                class: { input: true, "is-danger": _vm.errors.has("ctrDate") },
                attrs: {
                  name: "ctrDatePEA",
                  format: "DD/MM/YYYY",
                  "data-vv-as": "สัญญาลงวันที่",
                  disabled: this.reqType !== 1 && this.appVo.modifyFlag !== "Y",
                  lang: "th",
                  placeholder: ""
                },
                model: {
                  value: _vm.ctrDatePEA,
                  callback: function($$v) {
                    _vm.ctrDatePEA = $$v
                  },
                  expression: "ctrDatePEA"
                }
              }),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("ctrDatePEA"),
                      expression: "errors.has('ctrDatePEA')"
                    }
                  ],
                  staticClass: "help is-danger"
                },
                [_vm._v(_vm._s(_vm.errors.first("ctrDatePEA")))]
              )
            ],
            1
          )
        ])
      : _vm._e(),
    this.specificVo.lgDescription3Flag == "Y"
      ? _c("div", { staticClass: "form-row div-valign" }, [
          _c("div", { staticClass: "form-group col-md-6" }, [
            _c("label", [_vm._v(_vm._s(_vm.labelLgDescription3))]),
            this.isRequiredLgDescription3
              ? _c("span", { staticClass: "required" }, [_vm._v("*")])
              : _vm._e(),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.lgDescription3,
                  expression: "lgDescription3"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: this.isRequiredLgDescription3 },
                  expression: "{ required: this.isRequiredLgDescription3 }"
                }
              ],
              staticClass: "form-control",
              class: {
                input: true,
                "is-danger": _vm.errors.has("lgDescription3")
              },
              attrs: {
                name: "lgDescription3",
                "data-vv-as": "ชื่อสัญญาหลัก",
                disabled: this.reqType !== 1 && this.appVo.modifyFlag !== "Y",
                maxlength: "500",
                type: "text"
              },
              domProps: { value: _vm.lgDescription3 },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.lgDescription3 = $event.target.value
                }
              }
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("lgDescription3"),
                    expression: "errors.has('lgDescription3')"
                  }
                ],
                staticClass: "help is-danger"
              },
              [_vm._v("กรุณากรอก " + _vm._s(_vm.labelLgDescription3))]
            )
          ])
        ])
      : _vm._e(),
    _c("div", { staticClass: "form-row div-valign" }, [
      this.specificVo.projectIdFlag == "Y"
        ? _c("div", { staticClass: "form-group col-md-6" }, [
            _c("label", { staticStyle: { display: "contents" } }, [
              _vm._v(_vm._s(_vm.labelProjectId))
            ]),
            this.isRequiredProjectId
              ? _c("span", { staticClass: "required" }, [_vm._v("*")])
              : _vm._e(),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.projectId,
                  expression: "projectId"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: this.isRequiredProjectId },
                  expression: "{ required: this.isRequiredProjectId }"
                }
              ],
              staticClass: "form-control",
              class: { input: true, "is-danger": _vm.errors.has("projectId") },
              attrs: {
                name: "projectId",
                "data-vv-as": "เลขที่โครงการ",
                disabled: this.reqType !== 1 && this.appVo.modifyFlag !== "Y",
                maxlength: "50",
                type: "text"
              },
              domProps: { value: _vm.projectId },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.projectId = $event.target.value
                }
              }
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("projectId"),
                    expression: "errors.has('projectId')"
                  }
                ],
                staticClass: "help is-danger"
              },
              [_vm._v("กรุณากรอก " + _vm._s(_vm.labelProjectId))]
            )
          ])
        : _vm._e()
    ]),
    _c("div", { staticClass: "form-row div-valign" }, [
      this.specificVo.projectNameFlag == "Y"
        ? _c("div", { staticClass: "form-group col-md-6" }, [
            _c("label", { staticStyle: { display: "contents" } }, [
              _vm._v(_vm._s(_vm.labelProjectName))
            ]),
            this.isRequiredProjectName
              ? _c("span", { staticClass: "required" }, [_vm._v("*")])
              : _vm._e(),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.projectName,
                  expression: "projectName"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: this.isRequiredProjectName },
                  expression: "{ required: this.isRequiredProjectName }"
                }
              ],
              staticClass: "form-control",
              class: {
                input: true,
                "is-danger": _vm.errors.has("projectName")
              },
              attrs: {
                name: "projectName",
                "data-vv-as": "ข้อมูล",
                disabled: this.reqType !== 1 && this.appVo.modifyFlag !== "Y",
                maxlength: "500",
                type: "text"
              },
              domProps: { value: _vm.projectName },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.projectName = $event.target.value
                }
              }
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("projectName"),
                    expression: "errors.has('projectName')"
                  }
                ],
                staticClass: "help is-danger"
              },
              [_vm._v("กรุณากรอก " + _vm._s(_vm.labelProjectName))]
            )
          ])
        : _vm._e()
    ]),
    _c("div", { staticClass: "form-row div-valign" }, [
      this.specificVo.productTypeFlag == "Y"
        ? _c("div", { staticClass: "form-group col-md-6" }, [
            _c("label", { staticStyle: { display: "contents" } }, [
              _vm._v(_vm._s(_vm.labelProductType))
            ]),
            this.isRequiredProductType
              ? _c("span", { staticClass: "required" }, [_vm._v("*")])
              : _vm._e(),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.productType,
                  expression: "productType"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: this.isRequiredProductType },
                  expression: "{ required: this.isRequiredProductType }"
                }
              ],
              staticClass: "form-control",
              class: {
                input: true,
                "is-danger": _vm.errors.has("productType")
              },
              attrs: {
                name: "productType",
                "data-vv-as": "ข้อมูล",
                disabled: this.reqType !== 1 && this.appVo.modifyFlag !== "Y",
                maxlength: "500",
                type: "text"
              },
              domProps: { value: _vm.productType },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.productType = $event.target.value
                }
              }
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("productType"),
                    expression: "errors.has('productType')"
                  }
                ],
                staticClass: "help is-danger"
              },
              [_vm._v("กรุณากรอก " + _vm._s(_vm.labelProductType))]
            )
          ])
        : _vm._e()
    ]),
    _c("div", { staticClass: "form-row div-valign" }, [
      this.specificVo.collectionPhaseFlag == "Y"
        ? _c("div", { staticClass: "form-group col-md-6" }, [
            _c("label", { staticStyle: { display: "contents" } }, [
              _vm._v("งวดเงินทั้งหมด(เริ่มต้น/สิ้นสุด)")
            ]),
            this.isRequiredCollectionPhase
              ? _c("span", { staticClass: "required" }, [_vm._v("*")])
              : _vm._e(),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.collectionPhase,
                  expression: "collectionPhase"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: this.isRequiredCollectionPhase },
                  expression: "{ required: this.isRequiredCollectionPhase }"
                }
              ],
              staticClass: "form-control",
              class: {
                input: true,
                "is-danger": _vm.errors.has("collectionPhase")
              },
              attrs: {
                name: "collectionPhase",
                "data-vv-as": "งวดเงินทั้งหมด(เริ่มต้น/สิ้นสุด)",
                disabled: this.reqType !== 1 && this.appVo.modifyFlag !== "Y",
                maxlength: "500",
                type: "text"
              },
              domProps: { value: _vm.collectionPhase },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.collectionPhase = $event.target.value
                }
              }
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("collectionPhase"),
                    expression: "errors.has('collectionPhase')"
                  }
                ],
                staticClass: "help is-danger"
              },
              [_vm._v(_vm._s(_vm.errors.first("collectionPhase")))]
            )
          ])
        : _vm._e()
    ]),
    _c("div", { staticClass: "form-row div-valign" }, [
      this.specificVo.projectBudgetAmtFlag == "Y"
        ? _c(
            "div",
            { staticClass: "form-group col-md-6" },
            [
              _c("label", { staticStyle: { display: "contents" } }, [
                _vm._v(_vm._s(_vm.labelProjectBudgetAmt))
              ]),
              this.isRequiredProjectBudgetAmt
                ? _c("span", { staticClass: "required" }, [_vm._v("*")])
                : _vm._e(),
              _c("vue-numeric", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: { required: this.isRequiredProjectBudgetAmt },
                    expression: "{ required: this.isRequiredProjectBudgetAmt }"
                  }
                ],
                staticClass: "form-control",
                class: {
                  input: true,
                  "is-danger": _vm.errors.has("projectBudgetAmt")
                },
                attrs: {
                  name: "projectBudgetAmt",
                  precision: 2,
                  "data-vv-as": "มูลค่าขั้นต่ำของคลื่นความถี่",
                  disabled: this.reqType !== 1 && this.appVo.modifyFlag !== "Y"
                },
                on: {
                  keypress: function($event) {
                    return _vm.isNumber($event)
                  }
                },
                model: {
                  value: _vm.projectBudgetAmt,
                  callback: function($$v) {
                    _vm.projectBudgetAmt = $$v
                  },
                  expression: "projectBudgetAmt"
                }
              }),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("projectBudgetAmt"),
                      expression: "errors.has('projectBudgetAmt')"
                    }
                  ],
                  staticClass: "help is-danger"
                },
                [_vm._v(_vm._s(_vm.errors.first("projectBudgetAmt")))]
              )
            ],
            1
          )
        : _vm._e()
    ]),
    _c("div", { staticClass: "form-row div-valign" }, [
      this.specificVo.seqNoFlag == "Y"
        ? _c("div", { staticClass: "form-group col-md-6" }, [
            _c("label", { staticStyle: { display: "contents" } }, [
              _vm._v("ลำดับผู้ยื่นคำขอตามคลื่นความถี่")
            ]),
            this.isRequiredSeqNo
              ? _c("span", { staticClass: "required" }, [_vm._v("*")])
              : _vm._e(),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.seqNo,
                  expression: "seqNo"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: this.isRequiredSeqNo },
                  expression: "{ required: this.isRequiredSeqNo }"
                }
              ],
              staticClass: "form-control",
              class: { input: true, "is-danger": _vm.errors.has("seqNo") },
              attrs: {
                name: "seqNo",
                "data-vv-as": "ลำดับผู้ยื่นคำขอตามคลื่นความถี่",
                disabled: this.reqType !== 1 && this.appVo.modifyFlag !== "Y",
                maxlength: "500",
                type: "text"
              },
              domProps: { value: _vm.seqNo },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.seqNo = $event.target.value
                }
              }
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("seqNo"),
                    expression: "errors.has('seqNo')"
                  }
                ],
                staticClass: "help is-danger"
              },
              [_vm._v(_vm._s(_vm.errors.first("seqNo")))]
            )
          ])
        : _vm._e()
    ]),
    _c("div", { staticClass: "form-row div-valign" }, [
      this.specificVo.bidExpireDateFlag == "Y"
        ? _c(
            "div",
            { staticClass: "form-group col-md-6" },
            [
              _c("label", [_vm._v(_vm._s(_vm.labelBidExpireDate))]),
              this.isRequiredBidExpireDate
                ? _c("span", { staticClass: "required" }, [_vm._v("*")])
                : _vm._e(),
              _c("date-picker", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: { required: this.isRequiredBidExpireDate },
                    expression: "{ required: this.isRequiredBidExpireDate }"
                  }
                ],
                ref: "bidExpireDate",
                class: {
                  input: true,
                  "is-danger": _vm.errors.has("bidExpireDate")
                },
                attrs: {
                  name: "bidExpireDate",
                  format: "DD/MM/YYYY",
                  "data-vv-as": "วันที่สิ้นสุดการวางหลักประกัน",
                  editable: false,
                  disabled: this.reqType !== 1 && this.appVo.modifyFlag !== "Y",
                  "not-before": new Date(),
                  lang: "th",
                  placeholder: ""
                },
                model: {
                  value: _vm.bidExpireDate,
                  callback: function($$v) {
                    _vm.bidExpireDate = $$v
                  },
                  expression: "bidExpireDate"
                }
              }),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("bidExpireDate"),
                      expression: "errors.has('bidExpireDate')"
                    }
                  ],
                  staticClass: "help is-danger"
                },
                [_vm._v("กรุณากรอก " + _vm._s(_vm.labelBidExpireDate))]
              )
            ],
            1
          )
        : _vm._e()
    ]),
    _c("div", { staticClass: "form-row div-valign" }, [
      this.specificVo.guaranteePriceAmtFlag == "Y"
        ? _c(
            "div",
            { staticClass: "form-group col-md-6" },
            [
              _c("label", [_vm._v(_vm._s(_vm.labelGuaranteePriceAmt))]),
              this.isRequiredGuaranteePriceAmt
                ? _c("span", { staticClass: "required" }, [_vm._v("*")])
                : _vm._e(),
              _c("vue-numeric", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: {
                      required: this.isRequiredGuaranteePriceAmt,
                      min_value: 0.01
                    },
                    expression:
                      "{ required: this.isRequiredGuaranteePriceAmt, min_value: 0.01}"
                  }
                ],
                staticClass: "form-control",
                class: {
                  input: true,
                  "is-danger": _vm.errors.has("guaranteePriceAmt")
                },
                attrs: {
                  name: "guaranteePriceAmt",
                  precision: 2,
                  "data-vv-as": "จํานวนเงินในการวางประกัน",
                  disabled: this.reqType !== 1 && this.appVo.modifyFlag !== "Y"
                },
                on: {
                  keypress: function($event) {
                    return _vm.isNumber($event)
                  }
                },
                model: {
                  value: _vm.guaranteePriceAmt,
                  callback: function($$v) {
                    _vm.guaranteePriceAmt = $$v
                  },
                  expression: "guaranteePriceAmt"
                }
              }),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("guaranteePriceAmt"),
                      expression: "errors.has('guaranteePriceAmt')"
                    }
                  ],
                  staticClass: "help is-danger"
                },
                [
                  _vm._v(
                    _vm._s(_vm.labelGuaranteePriceAmt) + " ต้องมีค่ามากกว่า 0"
                  )
                ]
              )
            ],
            1
          )
        : _vm._e()
    ]),
    _c("div", { staticClass: "form-row div-valign" }, [
      this.specificVo.percentageFlag == "Y"
        ? _c(
            "div",
            { staticClass: "form-group col-md-6" },
            [
              _c("label", [_vm._v(_vm._s(_vm.labelPercentage))]),
              this.isRequiredPercentage
                ? _c("span", { staticClass: "required" }, [_vm._v("*")])
                : _vm._e(),
              _c("vue-numeric", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: {
                      required: this.isRequiredPercentage,
                      min_value: 0.01,
                      max_value: 100.0
                    },
                    expression:
                      "{\n          required: this.isRequiredPercentage,\n          min_value: 0.01,\n          max_value: 100.0,\n        }"
                  }
                ],
                staticClass: "form-control",
                class: {
                  input: true,
                  "is-danger": _vm.errors.has("percentage")
                },
                attrs: {
                  name: "percentage",
                  precision: 2,
                  "data-vv-as": "อัตราร้อยละ ในการวางหลักประกัน",
                  disabled: this.reqType !== 1 && this.appVo.modifyFlag !== "Y"
                },
                on: {
                  keypress: function($event) {
                    return _vm.isNumber($event)
                  },
                  blur: function($event) {
                    return _vm.validPercent()
                  }
                },
                model: {
                  value: _vm.percentage,
                  callback: function($$v) {
                    _vm.percentage = $$v
                  },
                  expression: "percentage"
                }
              }),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("percentage"),
                      expression: "errors.has('percentage')"
                    }
                  ],
                  staticClass: "help is-danger"
                },
                [_vm._v("กรุณากรอก " + _vm._s(_vm.labelPercentage))]
              )
            ],
            1
          )
        : _vm._e()
    ]),
    _c("div", { staticClass: "form-row div-valign" }, [
      this.specificVo.contractPeriodFlag == "Y"
        ? _c("div", { staticClass: "form-group col-md-6" }, [
            _c("label", [_vm._v("งวดที่ประกันผลงาน")]),
            this.isRequiredContractPeriod
              ? _c("span", { staticClass: "required" }, [_vm._v("*")])
              : _vm._e(),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.contractPeriod,
                  expression: "contractPeriod"
                }
              ],
              staticClass: "form-control",
              class: {
                input: true,
                "is-danger": _vm.errors.has("contractPeriod")
              },
              attrs: {
                name: "contractPeriod",
                "data-vv-as": "งวดที่ประกันผลงาน",
                disabled: this.reqType !== 1 && this.appVo.modifyFlag !== "Y",
                maxlength: "500",
                type: "text"
              },
              domProps: { value: _vm.contractPeriod },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.contractPeriod = $event.target.value
                }
              }
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("contractPeriod"),
                    expression: "errors.has('contractPeriod')"
                  }
                ],
                staticClass: "help is-danger"
              },
              [_vm._v(_vm._s(_vm.errors.first("contractPeriod")))]
            )
          ])
        : _vm._e()
    ]),
    _c("div", { staticClass: "form-row div-valign" }, [
      this.specificVo.advancePaymentAmtFlag == "Y"
        ? _c(
            "div",
            { staticClass: "form-group col-md-6" },
            [
              _c("label", [_vm._v("เงินค่าจ้างล่วงหน้า")]),
              this.isRequiredAdvancePaymentAmtAmt
                ? _c("span", { staticClass: "required" }, [_vm._v("*")])
                : _vm._e(),
              _c("vue-numeric", {
                staticClass: "form-control",
                class: {
                  input: true,
                  "is-danger": _vm.errors.has("advancePaymentAmt")
                },
                attrs: {
                  name: "advancePaymentAmt",
                  precision: 2,
                  "data-vv-as": "เงินค่าจ้างล่วงหน้า",
                  disabled: this.reqType !== 1 && this.appVo.modifyFlag !== "Y"
                },
                on: {
                  keypress: function($event) {
                    return _vm.isNumber($event)
                  }
                },
                model: {
                  value: _vm.advancePaymentAmt,
                  callback: function($$v) {
                    _vm.advancePaymentAmt = $$v
                  },
                  expression: "advancePaymentAmt"
                }
              }),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.errors.has("advancePaymentAmt"),
                      expression: "errors.has('advancePaymentAmt')"
                    }
                  ],
                  staticClass: "help is-danger"
                },
                [_vm._v(_vm._s(_vm.errors.first("advancePaymentAmt")))]
              )
            ],
            1
          )
        : _vm._e()
    ]),
    _c("div", { staticClass: "form-row div-valign" }, [
      this.specificVo.projectOwnerFlag == "Y"
        ? _c("div", { staticClass: "form-group col-md-12" }, [
            _c("label", [_vm._v(_vm._s(_vm.labelProjectOwner))]),
            this.isRequiredProjectOwner
              ? _c("span", { staticClass: "required" }, [_vm._v("*")])
              : _vm._e(),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.projectOwner,
                  expression: "projectOwner"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: this.isRequiredProjectOwner },
                  expression: "{ required: this.isRequiredProjectOwner }"
                }
              ],
              staticClass: "form-control",
              class: {
                input: true,
                "is-danger": _vm.errors.has("projectOwner")
              },
              attrs: {
                name: "projectOwner",
                "data-vv-as": "ข้อมูล",
                disabled: this.reqType !== 1 && this.appVo.modifyFlag !== "Y",
                maxlength: "500",
                type: "text"
              },
              domProps: { value: _vm.projectOwner },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.projectOwner = $event.target.value
                }
              }
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("projectOwner"),
                    expression: "errors.has('projectOwner')"
                  }
                ],
                staticClass: "help is-danger"
              },
              [_vm._v("กรุณากรอก " + _vm._s(_vm.labelProjectOwner))]
            )
          ])
        : _vm._e()
    ]),
    _c("div", { staticClass: "form-row div-valign" }, [
      this.specificVo.manyCtrNoFlag == "Y"
        ? _c("div", { staticClass: "form-group col-md-12" }, [
            _c("label", [_vm._v(_vm._s(_vm.labelManyCtrNo))]),
            this.isRequiredManyCtrNo
              ? _c("span", { staticClass: "required" }, [_vm._v("*")])
              : _vm._e(),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.manyCtrNo,
                  expression: "manyCtrNo"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: this.isRequiredManyCtrNo },
                  expression: "{ required: this.isRequiredManyCtrNo }"
                }
              ],
              staticClass: "form-control",
              class: { input: true, "is-danger": _vm.errors.has("manyCtrNo") },
              attrs: {
                name: "manyCtrNo",
                "data-vv-as": "เลขที่สัญญา ตั้งแต่ฉบับที่ 2",
                disabled: this.reqType !== 1 && this.appVo.modifyFlag !== "Y",
                maxlength: "400",
                type: "text"
              },
              domProps: { value: _vm.manyCtrNo },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.manyCtrNo = $event.target.value
                }
              }
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("manyCtrNo"),
                    expression: "errors.has('manyCtrNo')"
                  }
                ],
                staticClass: "help is-danger"
              },
              [_vm._v("กรุณากรอก " + _vm._s(_vm.labelManyCtrNo))]
            )
          ])
        : _vm._e()
    ]),
    _c("div", { staticClass: "form-row div-valign" }, [
      this.specificVo.manyCtrDateFlag == "Y"
        ? _c("div", { staticClass: "form-group col-md-12" }, [
            _c("label", [_vm._v(_vm._s(_vm.labelManyCtrDate))]),
            this.isRequiredManyCtrDate
              ? _c("span", { staticClass: "required" }, [_vm._v("*")])
              : _vm._e(),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.manyCtrDate,
                  expression: "manyCtrDate"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: this.isRequiredManyCtrDate },
                  expression: "{ required: this.isRequiredManyCtrDate }"
                }
              ],
              staticClass: "form-control",
              class: { input: true, "is-danger": _vm.errors.has("manyCtrNo") },
              attrs: {
                name: "manyCtrDate",
                "data-vv-as":
                  "สัญญาลงวันที่ ตั้งแต่ฉบับที่ 2: (yyyy-mm-dd,yyyy-mm-dd,....)",
                disabled: this.reqType !== 1 && this.appVo.modifyFlag !== "Y",
                maxlength: "400",
                type: "text"
              },
              domProps: { value: _vm.manyCtrDate },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.manyCtrDate = $event.target.value
                }
              }
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("manyCtrDate"),
                    expression: "errors.has('manyCtrDate')"
                  }
                ],
                staticClass: "help is-danger"
              },
              [_vm._v("กรุณากรอก " + _vm._s(_vm.labelManyCtrDate))]
            )
          ])
        : _vm._e()
    ]),
    _c("div", { staticClass: "form-row div-valign" }, [
      this.specificVo.manyCtrNameFlag == "Y"
        ? _c("div", { staticClass: "form-group col-md-12" }, [
            _c("label", [_vm._v(_vm._s(_vm.labelManyCtrName))]),
            this.isRequiredManyCtrName
              ? _c("span", { staticClass: "required" }, [_vm._v("*")])
              : _vm._e(),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.manyCtrName,
                  expression: "manyCtrName"
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: this.isRequiredManyCtrName },
                  expression: "{ required: this.isRequiredManyCtrName }"
                }
              ],
              staticClass: "form-control",
              class: { input: true, "is-danger": _vm.errors.has("manyCtrNo") },
              attrs: {
                name: "manyCtrName",
                "data-vv-as":
                  "ชื่อสัญญาที่ค้ำประกันเพิ่มเติม กรณีมีสัญญาที่ค้ำประกันตั้งแต่สองฉบับขึ้นไป",
                disabled: this.reqType !== 1 && this.appVo.modifyFlag !== "Y",
                maxlength: "500",
                type: "text"
              },
              domProps: { value: _vm.manyCtrName },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.manyCtrName = $event.target.value
                }
              }
            }),
            _c(
              "span",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.errors.has("manyCtrName"),
                    expression: "errors.has('manyCtrName')"
                  }
                ],
                staticClass: "help is-danger"
              },
              [_vm._v("กรุณากรอก " + _vm._s(_vm.labelManyCtrName))]
            )
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }